import React, { useContext } from 'react';
import styled from 'styled-components';
import { Back, SubmitButton } from '..';
import { QuizContext } from '../../../store/quiz';
import { media } from '../../../utils/styles';

export const Text = ({ data }) => {
  const {
    store: { nextStep, prevStep },
  } = useContext(QuizContext);

  const {
    primary: { button_text, image, show_quote, text },
  } = data;

  return (
    <Inner>
      <Content>
        {show_quote && (
          <Quote
            width="32"
            height="25"
            viewBox="0 0 32 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 25H10.7563V17.5034C10.7563 12.1045 12.5042 7.87482 15.0252 3.81706L8.70588 0C4.03361 3.88583 0 11.2792 0 17.5722V25ZM16.9748 25H27.7311V17.5034C27.7311 12.1045 29.479 7.87482 32 3.81706L25.6807 0C21.0084 3.88583 16.9748 11.2792 16.9748 17.5722V25Z"
              fill="black"
            />
          </Quote>
        )}
        <TextContent dangerouslySetInnerHTML={{ __html: text.html }} />
        <Footer>
          <div>
            <SubmitButton onClick={nextStep}>{button_text}</SubmitButton>
          </div>
          <Back onBack={prevStep} />
        </Footer>
      </Content>
      <Image>
        <img src={`${image.url}&width=430`} alt="" sizes="400px" />
      </Image>
    </Inner>
  );
};

const Footer = styled.div`
  display: inline-block;
  text-align: center;
  ${media.tablet} {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
`;

const Quote = styled.svg`
  position: absolute;
  top: -57px;
  left: 0;
  ${media.tablet} {
    position: static;
    margin: 0 0 32px;
  }
`;

const TextContent = styled.div`
  font-size: 16px;
  line-height: 1.9;
  margin: 0 0 40px;
  h1,
  h2,
  h3 {
    font-size: 32px;
    line-height: 1.4;
    margin: 0 0 15px;
    ${media.phone} {
      font-size: 24px;
      margin: 0 0 15px;
    }
  }
  em {
    font-style: italic;
  }
  strong {
    font-weight: 700;
  }
`;

const Image = styled.div`
  flex: 1;
  background: #f5f6f7;
  > img {
    position: relative;
    top: -24px;
    left: -24px;
  }
  ${media.tablet} {
    width: calc(100% - 20px);
    margin-left: auto;
    order: 1;
    > img {
      top: -20px;
      left: -20px;
    }
  }
`;

const Content = styled.div`
  margin-right: 172px;
  width: 406px;
  position: relative;
  ${media.tablet} {
    order: 2;
    width: 100%;
    margin: 40px 0 0;
  }
`;

const Inner = styled.div`
  display: flex;
  align-items: center;
  ${media.tablet} {
    flex-direction: column;
  }
`;
